const supportsRequestIdleCallback = typeof requestIdleCallback === 'function';

const requestIdleCallbackShim = (callback) => {
    return setTimeout(() => callback(), 0);
};

export const rIC = supportsRequestIdleCallback ? requestIdleCallback : requestIdleCallbackShim;
